export enum RentComponentErrorMessages {
    MESSAGE_TIME = 'check_if_your_time_picked_correctly',
    MESSAGE_DATE = 'check_if_your_date_picked_correctly',
    MESSAGE_LOCATION = 'enter_pickup_end_location_address',
    MESSAGE_DESTINATION = 'enter_destination_location',
}